import { render, staticRenderFns } from "./ServiceTeaser.vue?vue&type=template&id=20ba3c07"
import script from "./ServiceTeaser.vue?vue&type=script&lang=js"
export * from "./ServiceTeaser.vue?vue&type=script&lang=js"
import style0 from "./ServiceTeaser.vue?vue&type=style&index=0&id=20ba3c07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports